import {
	Box,
	Card,
	CardContent,
	Container,
	Divider,
	IconButton,
	Tooltip,
	Typography,
} from "@mui/material";
import { useEffect, useState } from "react";

import EditIcon from "@mui/icons-material/Edit";
import axios from "axios";
import { Helmet } from "react-helmet-async";
import { useParams } from "react-router";
import ModalsWrapper from "src/components/Modals/ModalsWrapper";
import SuspenseLoader from "src/components/SuspenseLoader";
import { url } from "src/Helpers/utils/constants";
import SingleGuestAndSpeakerDetails from "./SingleGuestAndSpeakerDetails";
import UpdateGuestAndSpeaker from "./UpdateGuestAndSpeaker";
import { useApiQuery } from "src/hooks/useApiQuery";
import type { IGuest } from "src/Types/module/guestAndSpeaker/type/guestAndSpeaker";

const SingleGuestAndSpeaker = () => {
	const [showModal, setShowModal] = useState<boolean>(false);

	const { id } = useParams();

	const { data: guest, isLoading } = useApiQuery<IGuest>({
		endPoint: `/api/fair/get/single/guest-speaker/guest-speaker-id/${id}`,
		queryKeys: ["Guest", id],
	});

	return (
		<div>
			<Helmet>
				<title>BTTF - Single Guest & Speaker</title>
			</Helmet>
			<Container sx={{ mt: 4 }} maxWidth="xl">
				<Card>
					<CardContent>
						<Box
							sx={{
								display: "flex",
								justifyContent: "space-between",
								alignItems: "center",
								marginBottom: "5px",
							}}
						>
							<Typography variant="h4" color="text.primary">
								Guest & Speaker
							</Typography>
							<Box
								sx={{
									display: "flex",
									justifyContent: "space-between",
									alignItems: "center",
									gap: "5px",
								}}
							>
								<Tooltip title="Edit">
									<IconButton
										onClick={() => setShowModal(!showModal)}
										sx={{ cursor: "pointer" }}
									>
										<EditIcon />
									</IconButton>
								</Tooltip>
							</Box>
						</Box>
						<Divider />
						{/* Guest and Speaker Details */}
						{isLoading ? (
							<SuspenseLoader />
						) : (
							<SingleGuestAndSpeakerDetails guest={guest} />
						)}

						{/* UPDATE */}
						<ModalsWrapper
							showModal={showModal}
							setShowModal={setShowModal}
							modalData={{ title: "Update Guest and Speaker" }}
						>
							<UpdateGuestAndSpeaker
								guest={guest}
								setShowModal={setShowModal}
							/>
						</ModalsWrapper>
					</CardContent>
				</Card>
			</Container>
		</div>
	);
};

export default SingleGuestAndSpeaker;
